var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideosIcon = function SvgVideosIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_465",
    "data-name": "Grupo 465",
    transform: "translate(-475 -46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    transform: "translate(475 46)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 1 C 3.242989540100098 1 1 3.242989540100098 1 6 C 1 8.757009506225586 3.242989540100098 11 6 11 C 8.757009506225586 11 11 8.757009506225586 11 6 C 11 3.242989540100098 8.757009506225586 1 6 1 M 6 0 C 9.31371021270752 0 12 2.68628978729248 12 6 C 12 9.31371021270752 9.31371021270752 12 6 12 C 2.68628978729248 12 0 9.31371021270752 0 6 C 0 2.68628978729248 2.68628978729248 0 6 0 Z",
    stroke: "none",
    fill: "#406867"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_238",
    "data-name": "Trazado 238",
    transform: "translate(484.5 48.5) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.518-.9,7,6H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.513102054595947 1.313176870346069 L 1.632622718811035 4.999997615814209 L 5.37478494644165 4.999997615814209 L 3.513102054595947 1.313176870346069 M 3.517580032348633 -0.896481990814209 L 7 5.999997615814209 L 0 5.999997615814209 L 3.517580032348633 -0.896481990814209 Z",
    stroke: "none",
    fill: "#406867"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideosIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "videos_icon.c8f03548678e413124137611efd311ca.svg";